import { motion } from "framer-motion";
import { MessageCircle, Phone, ShieldCheck, Clock, Truck } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, HERO_BG, openWhatsApp } from "@/data/content";

const fade = (d = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay: d, ease: [0.22, 1, 0.36, 1] },
});

const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#1731cf]"
    >
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="Sede Bahia Gás - Revenda Ultragaz" className="w-full h-full object-cover object-right" />
      </div>
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(95deg, rgba(18,38,180,0.98) 0%, rgba(20,42,190,0.94) 32%, rgba(20,42,190,0.6) 62%, rgba(12,26,130,0.35) 100%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 75% 35%, rgba(96,150,255,0.45), transparent 45%), radial-gradient(circle at 10% 90%, rgba(13,30,160,0.6), transparent 40%)",
        }}
      />
      <div className="absolute right-0 top-1/4 w-[600px] h-[600px] rounded-full border border-white/10" />
      <div className="absolute -left-32 bottom-10 w-[400px] h-[400px] rounded-full border border-white/10" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-36 pb-32">
        <div className="max-w-3xl">
          <motion.div {...fade(0)} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
            <span className="w-2.5 h-2.5 rounded-full bg-[#a3e635] animate-pulse" />
            <span className="text-white font-semibold text-sm">Revenda Autorizada Ultragaz</span>
          </motion.div>

          <motion.h1 {...fade(0.1)} className="text-white font-extrabold leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-7xl">
            Não espere
            <br />o gás acabar.
            <br />
            <span className="text-[#a3e635]">É só pedir!</span>
          </motion.h1>

          <motion.p {...fade(0.2)} className="text-white/75 text-lg sm:text-xl mt-8 max-w-xl leading-relaxed">
            Entregamos gás de cozinha e água mineral em Ipatinga com rapidez e segurança. Mais de 33 anos de confiança.
          </motion.p>

          <motion.div {...fade(0.3)} className="flex flex-wrap gap-4 mt-10">
            <button
              data-testid="hero-whatsapp-btn"
              onClick={() => openWhatsApp()}
              className="flex items-center gap-3 bg-[#a3e635] hover:bg-[#92d420] text-[#0f1733] font-bold text-lg px-8 py-4 rounded-2xl shadow-xl shadow-[#a3e635]/30 transition-all hover:-translate-y-1"
            >
              <MessageCircle className="w-6 h-6" /> Chama no WhatsApp
            </button>
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="hero-phone-btn"
              className="flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white font-bold text-lg px-8 py-4 rounded-2xl transition-all hover:-translate-y-1"
            >
              <Phone className="w-5 h-5" /> {PHONE_DISPLAY}
            </a>
          </motion.div>

          <motion.div {...fade(0.45)} className="flex flex-wrap gap-x-10 gap-y-3 mt-12 text-white/80">
            <span className="flex items-center gap-2 font-medium"><ShieldCheck className="w-5 h-5 text-[#a3e635]" /> Segurança</span>
            <span className="flex items-center gap-2 font-medium"><Clock className="w-5 h-5 text-[#a3e635]" /> Entrega Rápida</span>
            <span className="flex items-center gap-2 font-medium"><Truck className="w-5 h-5 text-[#a3e635]" /> +33 Anos</span>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 leading-none">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 60C240 110 480 110 720 70C960 30 1200 30 1440 70V120H0V60Z" fill="white" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
